import { useDispatch } from "react-redux";
import { openPopup } from "../../../store/popupSlice"

export default function LandingItalyApps({ data, data1, data2, data3 }) {
  const dispatch = useDispatch();
  return (
    <>
      <section className="land2-Apps-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="land2-apps-head">
                <h4 className="heading center-heading gradiant-color">{data.title}</h4>
                <span>{data.desc}</span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-5 order-2 order-lg-1">

              {data.boxes && data.boxes.map((box, index) => (
                <div className="land2-app-box" key={index}>
                  <img loading="lazy" src={box.image} alt="icon" className="img-responsive" />
                  <div>
                    <h4>{box.title}</h4>
                    <p>{box.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="col-lg-7 order-1 order-lg-2">
              <div className="land2-app-image">
                <img loading="lazy" src={data?.rightImg || "/assets/home/land2-apps-1.webp"} alt="apps" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-12 order-3 order-lg-3">
              <div className="land2-rider-butn">
                <button onClick={() => dispatch(openPopup())} className="default-btn">{data.cta}</button>
                {/* <Link to={"/"}><button className="default-white">Explore More</button></Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="land2-Apps-area land2-apps-differ">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="land2-apps-head">
                <h4 className="heading center-heading gradiant-color">{data1.title}</h4>
                <span>{data1.desc}</span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-7">
              <div className="land2-app-image">
                <img loading="lazy" src={data1?.leftImg || "/assets/home/land2-apps-2.webp"} alt="apps" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-5">

              {data1.boxes && data1.boxes.map((box, index) => (
                <div className="land2-app-box" key={index}>
                  <img loading="lazy" src={box.image} alt="icon" className="img-responsive" />
                  <div>
                    <h4>{box.title}</h4>
                    <p>{box.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="col-lg-12">
              <div className="land2-rider-butn">
                <button onClick={() => dispatch(openPopup())} className="default-btn">{data.cta}</button>
                {/* <Link to={"/"}><button className="default-white">Explore More</button></Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="land2-Apps-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="land2-apps-head">
                <h4 className="heading center-heading gradiant-color">{data2.title}</h4>
                <span>{data2.desc}</span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-5 order-2 order-lg-1">
              {data2.boxes && data2.boxes.map((box, index) => (
                <div className="land2-app-box" key={index}>
                  <img loading="lazy" src={box.image} alt="icon" className="img-responsive" />
                  <div>
                    <h4>{box.title}</h4>
                    <p>{box.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="col-lg-7 order-1 order-lg-2">
              <div className="land2-app-image">
                <img loading="lazy" src="/assets/home/land2-apps-3.webp" alt="apps" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-12 order-3 order-lg-3">
              <div className="land2-rider-butn">
                <button onClick={() => dispatch(openPopup())} className="default-btn">{data.cta}</button>
                {/* <Link to={"/"}><button className="default-white">Explore More</button></Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="land2-Apps-area land2-apps-differ">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="land2-apps-head">
                <h4 className="heading center-heading gradiant-color">{data3.title}</h4>
                <span>{data3.desc}</span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-7">
              <div className="land2-app-image">
                <img loading="lazy" src="/assets/home/land2-apps-4.webp" alt="apps" className="img-responsive" />
              </div>
            </div>

            <div className="col-lg-5">
              {data3.boxes && data3.boxes.map((box, index) => (
                <div className="land2-app-box" key={index}>
                  <img loading="lazy" src={box.image} alt="icon" className="img-responsive" />
                  <div>
                    <h4>{box.title}</h4>
                    <p>{box.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="col-lg-12">
              <div className="land2-rider-butn">
                <button onClick={() => dispatch(openPopup())} className="default-btn">{data.cta}</button>
                {/* <Link to={"/"}><button className="default-white">Explore More</button></Link> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
